/**
 * Parses an incident reference to a numeric incident `id`.
 * Supports numeric ids and composite `"[sportId]-[incidentId]"` format.
 */
export function parseCompositeIncidentId(
  id: string | number | null | undefined,
): number | null {
  if (id === null || id === undefined) {
    return null
  }

  if (typeof id === 'number') {
    return id
  }

  const parts = id.split('-')
  const rawId = parts.length >= 2 ? parts[1] : id
  const numericId = rawId.trim() === '' ? NaN : +rawId

  return Number.isNaN(numericId) || numericId <= 0 ? null : numericId
}
